import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { labels, profile } from '../data/content';
import { FOCUS_RING } from './styles';

const LINK = `rounded-sm text-sm text-stone-600 underline underline-offset-4 hover:text-stone-900 ${FOCUS_RING}`;

export default function Contact() {
  const { t } = useLanguage();

  return (
    <footer id="contact" className="scroll-mt-28 py-24 md:scroll-mt-16">
      <div className="mx-auto max-w-5xl px-5 text-center">
        <h2 className="text-balance text-3xl font-bold tracking-tight md:text-4xl">{t(labels.contactTitle)}</h2>
        <p className="mx-auto mt-4 max-w-md text-pretty leading-relaxed text-stone-600">{t(labels.contactDesc)}</p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-10">
          <a
            href={`mailto:${profile.email}`}
            className={`inline-flex h-11 items-center rounded-sm bg-stone-900 px-6 text-sm font-medium text-stone-50 transition-colors hover:bg-stone-700 ${FOCUS_RING}`}
          >
            {profile.email}
          </a>
          <a href={`tel:${profile.phone.replace(/[^+\d]/g, '')}`} className={LINK}>
            {profile.phone}
          </a>
          <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className={LINK}>
            LinkedIn
          </a>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <a href={profile.resume.ko} download className={LINK}>
            {t(labels.resumeKo)} PDF
          </a>
          <a href={profile.resume.en} download className={LINK}>
            {t(labels.resumeEn)} PDF
          </a>
        </div>

        <p className="mt-20 text-xs text-stone-500">© {new Date().getFullYear()} Eunseong Lee. All rights reserved.</p>
      </div>
    </footer>
  );
}
